import produce from 'immer';

export const actions = {
  SIGNUP_ADMIN: 'SGINUP_ADMIN',
  SIGNUP_ADMIN_SUCCESS: 'SIGNUP_ADMIN_SUCCESS',
  SIGNUP_ARTISAN: 'SIGNUP_ARTISAN',
  SIGNUP_ARTISAN_SUCCESS: 'SIGNUP_ARTISAN_SUCCESS',
  SIGNUP_SUPPLIER: 'SIGNUP_SUPPLIER',
  SIGNUP_SUPPLIER_SUCCESS: 'SIGNUP_SUPPLIER_SUCCESS',
  SIGNUP_CUSTOMER: 'SIGNUP_CUSTOMER',
  SIGNUP_CUSTOMER_SUCCESS: 'SIGNUP_CUSTOMER_SUCCESS',
  UPDATE_AUTH_ARTISAN: 'UPDATE_AUTH_ARTISAN',
  UPDATE_AUTH_ARTISAN_SUCCESS: 'UPDATE_AUTH_ARTISAN_SUCCESS',
  UPDATE_AUTH_SUPPLIER: 'UPDATE_AUTH_SUPPLIER',
  UPDATE_AUTH_SUPPLIER_SUCCESS: 'UPDATE_AUTH_SUPPLIER_SUCCESS',
  UPDATE_AUTH_APPLICANT: 'UPDATE_AUTH_APPLICANT',
  UPDATE_AUTH_APPLICANT_SUCCESS: 'UPDATE_AUTH_APPLICANT_SUCCESS',
  UPDATE_AUTH_CUSTOMER: 'UPDATE_AUTH_CUSTOMER',
  UPDATE_AUTH_CUSTOMER_SUCCESS: 'UPDATE_AUTH_CUSTOMER_SUCCESS',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASsWORD_SUCCESS',
  RESET_PASSWORD: 'RESET_PASSWORD',

  AUTH_UPDATE_USER_SETTINGS: 'AUTH_UPDATE_USER_SETTINGS',
  AUTH_UPDATE_USER_SETTINGS_SUCCESS: 'AUTH_UPDATE_USER_SETTINGS_SUCCESS',
  AUTH_UPDATE_USER: 'AUTH_UPDATE_USER',
  AUTH_UPDATE_USER_SUCCESS: 'AUTH_UPDATE_USER_SUCCESS',
  /**
   * Misc
   */

  LOGIN_USER: 'LOGIN_USER',
  SET_USER_PROFILES: 'SET_USER_PROFILES',
  LOGOUT_USER: 'LOGOUT_USER',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  LOGOUT_USER_SUCCESS: 'LOGOUT_USER_SUCCESS',

  SET_AUTH_IS_LOADING: 'SET_AUTH_IS_LOADING'
};

const initialState = {
  user: null,
  token: null,
  profiles: null,
  isLoading: false,
  message: ''
};

export default produce((draft, action) => {
  const { type, payload } = action;
  if (!draft) {
    return initialState;
  }

  switch (type) {
    case actions.SIGNUP_ADMIN_SUCCESS: {
      draft.message = payload;
      break;
    }

    case actions.SIGNUP_ARTISAN_SUCCESS: {
      draft.message = payload;
      break;
    }
    case actions.SET_USER_PROFILES: {
      draft.profiles = payload;
    }
    case actions.SIGNUP_SUPPLIER_SUCCESS: {
      draft.message = payload;
      break;
    }
  

    case actions.SIGNUP_CUSTOMER_SUCCESS: {
      draft.message = payload;
      break;
    }

    case actions.LOGIN_USER_SUCCESS: {
      const { user, token } = payload;
      draft.user = user;
      draft.token = token;
      break;
    }
    case actions.AUTH_UPDATE_USER_SUCCESS:
    case actions.AUTH_UPDATE_USER_SETTINGS_SUCCESS: {
      const updatedUser = payload;
      draft.user = updatedUser;
      break;
    }
    case actions.LOGOUT_USER_SUCCESS: {
      draft.user = null;
      draft.token = null;
      break;
    }

    // case actions.FORGOT_PASSWORD_SUCCESS : {
    //   draft.message = payload;
    //   break;
    // }

    // Misc
    case actions.SET_AUTH_IS_LOADING: {
      const isLoading = payload;
      draft.isLoading = isLoading;
      break;
    }

    default:
      break;
  }
});
